<ng-container *ngIf="entities().length > 0">
  <ul nz-menu nzMode="horizontal" class="entity-nav-menu">
    <ng-container *ngFor="let tab of getVisibleEntities(); let i = index">
      <ng-container *ngIf="tab?.display_name">
        <li
          class="f-12"
          nz-menu-item
          (click)="changeTab(tab)"
          [nzSelected]="
            entity_display_name
              ? entity_display_name === tab.display_name
              : i === 0
          "
        >
          {{ tab.display_name }}
        </li>
      </ng-container>
      <ng-container *ngIf="tab?.gd_name">
        <li class="f-12" nz-submenu [nzTitle]="title" [nzPlacement]="'bottomCenter'">
          <ng-template #title>
 
            <div style="display: flex;align-items: center;column-gap: 7px;">
              {{ tab.gd_name }}
              <img class="arrow_icon" src="../../../../assets/images/icons/down_arrow.svg">
            </div>
          </ng-template>
          <ul>
            <ng-container *ngFor="let item of tab.child_data">
              <li              
                class="f-12"
                nz-menu-item
                (click)="changeTab(item)"
                [nzSelected]="
                  entity_display_name
                    ? entity_display_name === item.display_name
                    : i === 0
                "
              >
                {{ item.display_name }}
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ng-container>

    <!-- "More" entry for mobile to hold overflow entities -->
    <li
      class="f-12 more-tab"
      nz-submenu
      *ngIf="hasOverflow()"
      [nzTitle]="'More'"
      [nzPlacement]="'bottomCenter'"
    >
      <ul>
        <ng-container *ngFor="let extra of getOverflowEntities()">
          <!-- Simple entity -->
          <ng-container *ngIf="extra?.display_name">
            <li
              class="f-12"
              nz-menu-item
              (click)="changeTab(extra)"
              [nzSelected]="entity_display_name === extra.display_name"
            >
              {{ extra.display_name }}
            </li>
          </ng-container>

          <!-- Grouped entity with its own children: render as nested submenu inside More -->
          <ng-container *ngIf="extra?.gd_name && extra?.child_data">
            <li class="f-12" nz-submenu [nzTitle]="moreGroupTitle" [nzPlacement]="'bottomCenter'">
              <ng-template #moreGroupTitle>
                <div style="display: flex; align-items: center; column-gap: 7px;">
                  {{ extra.gd_name }}
                  <img class="arrow_icon" src="../../../../assets/images/icons/down_arrow.svg" />
                </div>
              </ng-template>
              <ul>
                <ng-container *ngFor="let child of extra.child_data">
                  <li
                    class="f-12"
                    nz-menu-item
                    (click)="changeTab(child)"
                    [nzSelected]="entity_display_name === child.display_name"
                  >
                    {{ child.display_name }}
                  </li>
                </ng-container>
              </ul>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </li>
  </ul>
</ng-container>

<ng-template #skeletonText>
  <div class="ghost" style="height: 20px; margin: auto; width: 100px"></div>
</ng-template>
